import { render, staticRenderFns } from "./ZandPayment.vue?vue&type=template&id=772a444d&scoped=true"
import script from "./ZandPayment.vue?vue&type=script&lang=js"
export * from "./ZandPayment.vue?vue&type=script&lang=js"
import style0 from "./ZandPayment.vue?vue&type=style&index=0&id=772a444d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a444d",
  null
  
)

export default component.exports